export default (sourceObject) => {
  if (!(typeof sourceObject === 'object' && sourceObject !== null))
    return sourceObject;
  Object.keys(sourceObject).forEach((keyName) => {
    if (sourceObject[keyName] === undefined) {
      delete sourceObject[keyName];
    } else {
      sourceObject[keyName] =
        sourceObject[keyName] === '' ? null : sourceObject[keyName];
    }
  });

  return sourceObject;
};
